import t from "../../../../helpers/t";
import React from "react";
import { Biscuit } from "../../../../../utils";

const SwitchesWide = (props) => {
  let mails = props.mails;
  let setIds = props.setIds;
  let onChangeType = props.onChangeType;
  let associates = props.associates;
  let usedMailTypes = props.usedMailTypes;
  let type = props.type;
  let in_array = props.in_array;

  let normStyle = {
    maxWidth: "30%",
    padding: "0",
  };
  let labelStyle = {
    maxWidth: "65%",
    minHeight: "40px",
    height: "0",
    minWidth: "65%",
    lineHeight: "20px",
  };
  let labelText = "";
  let newArr = {
    margin: "10px 0 10px 0",
    clear: "both",
    padding: "0",
  };
  let switchStyle = {
    minWidth: "50px",
    paddingLeft: "10px",
  };
  const setNormStyles = (key) => {
    if (key === 0) {
      normStyle = {
        maxWidth: "40%",
        padding: "0",
      };
      labelStyle = {
        maxWidth: "65%",
        minHeight: "40px",
        height: "0",
        minWidth: "65%",
        lineHeight: "20px",
      };
    }
  };
  const setLabelText = (key, label) => {
    if (key === 0) {
      labelText = t("get_message_if") + " " + t(label);
    } else {
      labelText = t(label);
    }
  };

  return (
    <>
      <div className="inb-form-group column medium-12 small-12">
        <hr />
      </div>
      <div className="inb-form-group column medium-12 small-12">
        <details open className="inb-form-group column medium-12 small-12">
          <summary style={{ color: "#EB6A3A" }}>{t(type, null, "capital")}</summary>
          {mails !== null && mails.length > 0 && (
            <>
              {mails.map((mail, key) => {
                if (type !== "orders") setNormStyles(0);
                return (
                  <>
                    <div
                      key={type + "_" + key}
                      className="inb-form-group column label-float-left top-spaceA medium-12 small-12"
                      style={normStyle}
                    >
                      <label className="inb-form__controlLabel" style={labelStyle}>
                        {t(mail.name, null, "capital")}
                      </label>
                      <div className="switch tiny inb-form__controllClass" style={switchStyle}>
                        <input
                          className="switch-input "
                          id={mail.name + "_subscribedSwitch"}
                          type="checkbox"
                          name={mail.id}
                          checked={in_array(mail.id, setIds)}
                          placeholder=""
                          onChange={(e) => onChangeType(e, mail.id)}
                        />
                        <label className="switch-paddle" htmlFor={mail.name + "_subscribedSwitch"}>
                          <span className="show-for-sr">Toggle content</span>
                        </label>
                      </div>
                    </div>
                  </>
                );
              })}
            </>
          )}
          {associates !== null && (
            <>
              <div style={{ clear: "both" }} />
              {associates.map((mails, key) => {
                return (
                  <>
                    <div className="inb-form-group column medium-12 small-12" style={newArr}>
                      <details open style={newArr}>
                        <summary>{t(usedMailTypes[key])}</summary>
                        {mails.map((val, key) => {
                          setNormStyles(key);
                          setLabelText(key, val.subname);
                          return (
                            <>
                              <div
                                className="inb-form-group column label-float-left top-space medium-4 small-12"
                                style={normStyle}
                              >
                                <label className="inb-form__controlLabel" style={labelStyle}>
                                  {labelText}
                                </label>
                                <div
                                  className="switch tiny inb-form__controllClass"
                                  style={switchStyle}
                                >
                                  <input
                                    className="switch-input "
                                    id={val.name + "_subscribedSwitch"}
                                    type="checkbox"
                                    name={val.id}
                                    checked={in_array(val.id, setIds)}
                                    placeholder=""
                                    onChange={(e) => onChangeType(e, val.id)}
                                  />
                                  <label
                                    className={
                                      "switch-paddle switch-paddle-" + Biscuit.get("user.client_id")
                                    }
                                    htmlFor={val.name + "_subscribedSwitch"}
                                  >
                                    <span className="show-for-sr">Toggle content</span>
                                  </label>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </details>
                      <div style={{ clear: "both" }}> </div>
                    </div>
                  </>
                );
              })}
            </>
          )}
        </details>
      </div>
    </>
  );
};

export default SwitchesWide;
